<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("location_risk_area") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_table == true">{{
              $t("table_validate")
            }}</span>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
               
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(responseAreaDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <!-- <div class="p-field p-col-12 p-lg-2 p-mt-3">
            <label>{{ $t("selectedChart") }}</label>
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-12 p-lg-12">
                <Dropdown
                  v-model="selectedChart"
                  :options="chartOptions"
                  optionLabel="name"
                  id="ds_selectedChart"
                />
              </div>
            </div>
          </div> -->

          <div class="p-col p-mt-3 p-ml-3">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10 p-lg-6">
                <label>{{ $t("disaster_type") }}</label>
                <MultiSelect
                  v-model="disasterTypeSelected"
                  :options="disasterTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>

              <div class="p-field p-col-2 p-lg-1 p-mt-4">
                <Button
                  @click="disasterTypeSelected = null
                          multiSelectClearFilerValue +=1"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>

          <div class="p-formgrid p-grid p-mt-4">

            <div class="p-grid">
            <div class="p-field p-col-6 p-lg-6 p-mt-2">
              <Button
                @click="clearSearchField()"
                :label="$t('clearBtn')"
                class="p-button-clear "
              />
            </div>
            <div class="p-field p-col-6 p-lg-6 p-mt-2"> <Button
                @click="search()
                cou=true"
                :label="$t('searchBtn')"
                class="p-button-info "
              /></div>
              
              
            
            </div>
            
          </div>


            <span class="p-invalid" v-if="error_disaster == true">{{
              $t("table_validate")
            }}</span>
          </div>

        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>

    <Dialog
      :modal="true"
      :header="$t('ResponseAreaModalHeader')"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue"
        :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>
    
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-lg-6">
        <div class="card p-fluid p-mt-2">
          <DataTable
            :value="table"
           
            :paginator="true"
            :scrollable="true"
      scrollHeight="500px"
            :rows="10"
            dataKey="id"
            :showGridlines ="true"
            :loading="loading"
            ref="dt"
            :exportFilename = "`สรุปจำนวนพื้นที่เสี่ยงภัย-${date}`"
            :rowHover="true"
            :filters="filters"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]"
            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
          >
          <template #header>
          <div class="p-grid p-col ">
            
            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;"   >
              <!-- Doe : excel 1/3 -->
              <download-excel
                  class   = "p-button-info "
                  :data   = "setData_Export()"
                  :fields = col
                  
                  name    = "สรุปจำนวนพื้นที่เสี่ยงภัย.xls">
              
                  <Button
                    :label="$t('exportBtn')"
                    class="p-button-info "
                    style="background-color: green;"
                    
                  />
                  
              </download-excel>
              <!-- Doe : excel 1/3 จบ -->
            </div>
            <div class="table-header " style="padding: 7px;"  >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
          
            <!-- Doe : PDF 1/3 จบ -->

          <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

              <!-- Doe ค้นหา  1/5 -->
              <span class="p-input-icon-left" v-if="(cou == false)">
                <i class="pi pi-search" />
                <InputText
                v-model="filter"
                
                  :placeholder="$t('searchHeader')"
                />
              </span>
              <span class="p-input-icon-left" v-else>
                <i class="pi pi-search" />
                <InputText
                v-model="filter"
                @input="searchTable()"
                
                  :placeholder="$t('searchHeader')"
                />
              </span>
              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>
            <template #empty>{{ $t("TableEmpty") }}</template>
            
              <Column
              field="system_name"
              :header="$t('RiskAreaLocation')"
              :sortable="true"
              headerStyle="width: 30rem; "
              
              
            >
              <template #body="dataTable" >
                
                  {{ dataTable.data.system_name }}
                
                
              </template>
            </Column>
            
            
            <div v-for="headers in headerLocation" :key="headers.id">
              <Column :header="headers.name" :field="headers.name" headerStyle="width: 10rem">
                <template #body="dataTable">
                  <div
                    v-for="result in result_table"
                    :key="JSON.stringify(result)"
                  >
                    <div v-if="dataTable.data.system_id == result.system_id" >
                      
                      <div v-if="headers.id == result.location_id" >
                        {{ result.amount_type }}
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
            </div>
          
          </DataTable>
        </div>
      </div>

      <div class="p-col-12 p-lg-6">
        <div class="card p-mt-2">
          <div class="chartAreaWrapper">
          <h5 class="centerText">{{ $t("TopicGraphRiskArea") }}</h5>
          <Chart :type="selectedChart.value" :data="barData" class="walking-speed-chart"/>
        </div>
      </div>
      </div>
    </div>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import responseAreaTable from "../ResponseAreaTable";
// เพิ่ม pdf กับ font
import { jsPDF } from "jspdf";
import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "report-risk-area-graph",
  components: {
    responseAreaTable,
    textFooter
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      cloneRe:[],
      // Doe ค้นหา  2/5 จบ

      responseArea_table: [],
      selectedResponseAreaData: null,
      table: [],
      filters: {},
      barData: [],
      error_table: false,
      error_disaster: false,

      disasterTypeOptions: [],
      disasterTypeSelected: null,
      showResponseArea: false,
      displayConfirmation: false,

      headerLocation: [],
      result_table: [],

      parentmessage_area: null,

      chartOptions: [],
      selectedChart: { id: 1, name: "แบบ Bar", value: "bar" },
      loading:false,
      // Doe : excel 2/3
      col:{},
      // Doe : excel 2/3 end
      // Doe : PDF 3/3
      H:[],
      cop:[],
      c:[],

      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"หน่วยงานรับผิดชอบ",
          textShow:"",
        },
        {
          DataName:"ที่ตั้งพื้นที่เสี่ยงภัย",
          textShow:"",
        },
        {
          DataName:"ประเภทสาธารณภัย",
          textShow:"",
        },
        {
          DataName:"ระดับความรุนแรง",
          textShow:"",
        },
      ],

      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {

            if(this.setData_Export().length === 0 ){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{

              this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});
            let dateObj = new Date();
            const result = dateObj.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
            let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`
             
            const doc = new jsPDF('p', 'pt');
            doc.addFileToVFS("m.ttf", font);
                  doc.addFont("m.ttf","m","normal");
                  doc.setFont("m");
   
              doc.autoTable({
                margin: { left: 15 ,right:15 }, 
                styles: {

                          font:'m',
                                       
                        },
                        headStyles:{
                          
                          fontSize: 9,
                          fontStyle: 'bolder',
                          minCellWidth: 30,
                          halign: 'center',
                          valign: 'middle',
                          fillColor:[95,154,250],
                        },
                        bodyStyles:{
                          fontSize: 7,
                          
                        },
                        columnStyles: {
                                        
                        },

                head: [this.H],
                columns:this.cop,
                body :this.setData_Export(),
                theme:'grid',

                  didParseCell:  (HookData) =>{
                  
                    if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined ) {
                      
                        HookData.cell.text = '-';
                    } 
                                       
                  },
                  didDrawPage: () => {
                  doc.setFontSize(13);
                  doc.text("ข้อมูล ณ วันที่ "+result,  570, 34, null, null, "right")
                  }  

              });

              var pageCount = doc.internal.getNumberOfPages()
              // console.log("pageCount",pageCount)
              for (let index = 0; index < pageCount; index++) {
                doc.setPage(index)
                doc.setFontSize(13);
                let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
                doc.text("หน้า "+pageCurrent + " จาก " +pageCount,575,815, null, null, "right")
              }
              
            // }
              doc.save('ตารางสรุปจำนวนพื้นที่เสี่ยงภัย(แนวตั้ง)'+ time +'.pdf');
            }
						
            
        },
        
            
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.setData_Export().length === 0){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
              
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
            let dateObj = new Date();
            const result = dateObj.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
            let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`
             
            const doc = new jsPDF('l', 'pt');
            doc.addFileToVFS("m.ttf", font);
                  doc.addFont("m.ttf","m","normal");
                  doc.setFont("m");
   
              doc.autoTable({
                margin: { left: 15 ,right:15 }, 
                styles: {

                          font:'m',
                                       
                        },
                        headStyles:{
                          
                          fontSize: 9,
                          fontStyle: 'bolder',
                          minCellWidth: 30,
                          halign: 'center',
                          valign: 'middle',
                          fillColor:[95,154,250],
                        },
                        bodyStyles:{
                          fontSize: 7,
                          
                        },
                        columnStyles: {
                                        
                        },

                head: [this.H],
                columns:this.cop,
                body :this.setData_Export(),
                theme:'grid',

                  didParseCell:  (HookData) =>{
                  
                    if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined ) {
                      
                        HookData.cell.text = '-';
                    } 
                                       
                  },
                  didDrawPage: () => {
                  doc.setFontSize(13);
                  doc.text("ข้อมูล ณ วันที่ "+result,  802, 34, null, null, "right")
                }      

              });

              var pageCount = doc.internal.getNumberOfPages()
              // console.log("pageCount",pageCount)
              for (let index = 0; index < pageCount; index++) {
                doc.setPage(index)
                doc.setFontSize(13);
                let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
                doc.text("หน้า "+pageCurrent + " จาก " +pageCount,802,570,null, null, "right")
              }

            // }
              doc.save('ตารางสรุปจำนวนพื้นที่เสี่ยงภัย(แนวนอน)'+ time +'.pdf');   
            }
          }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },

  async created() {
    this.chartOptions.push({ id: 1, name: "แบบ Bar", value: "bar" });
    this.chartOptions.push({ id: 2, name: "แบบ Pie", value: "pie" });
    this.chartOptions.push({ id: 3, name: "แบบ Line", value: "line" });
    this.chartOptions.push({ id: 4, name: "แบบ Doughnut", value: "doughnut" });
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-02" },
      })
      .then((response) => {
        this.disasterTypeOptions = response.data.data;
      });

      this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)
  },

  watch: {
    showResponseArea(val) {
      if (val == true) {
        if (this.responseArea_table.length > 0) {
          this.parentmessage_area = this.responseArea_table;
        } else {
          this.parentmessage_area = [];
        }
      }
    },

    responseArea_table(val) {
      if (val.length > 0) {
        this.error_table = false;
      }
    },

    disasterTypeOptions(val) {
      if (val != null) {
        this.disasterTypeSelected = val;
      }
    },

    disasterTypeSelected(val) {
      if (val != null) {
        this.error_disaster = false;
        if (val.length == 0) {
          this.disasterTypeSelected = null;
        }
      }
    },

    result_table(val) {
      if (val.length != 0) {
        var letters = "0123456789ABCDEF";
        var color = "#";
        var dataset = [];
        var result = [];

        for (let i = 0; i < val.length; i++) {
          result.push(val[i]);
        }
        var all_amount = [];
        for (let t = 0; t < this.headerLocation.length; t++) {
          for (let i = 0; i < this.disasterTypeSelected.length; i++) {
            for (let j = 0; j < result.length; j++) {
              if (this.headerLocation[t].id == result[j].location_id) {
                if (
                  this.disasterTypeSelected[i].system_id == result[j].system_id
                ) {
                  all_amount.push(`${result[j].amount_type}`);
                } else {
                  all_amount.push("0");
                }
              } else {
                all_amount.push("0");
              }
            }
          }
        }

        var number = [];
        var index;
        var all = [];
        for (let j = 0; j < this.headerLocation.length; j++) {
          for (let i = 1; i <= this.disasterTypeSelected.length; i++) {
            index = i * result.length;
            var temp = 0;
            for (let k = index - result.length; k < index; k++) {
              temp += Number(all_amount[k]);
            }
            number.push(temp);
          }
          all_amount = all_amount.slice(index);
          all.push({ id: number });
          number = [];
        }

        for (let j = 0; j < this.headerLocation.length; j++) {
          for (let k = 0; k < 6; k++) {
            color += letters[Math.floor(Math.random() * 16)];
          }
          dataset.push({
            label: `${this.headerLocation[j].name}`,
            backgroundColor: `${color}`,
            borderColor: `${color}`,
            data: all[j].id,
          });
          color = "#";
        }

        this.barData = {
          labels: this.label,
          datasets: dataset,
        };
      }
    },
  },

  mounted() {},
  methods: {
    exportCSV() {
      debugger;
      this.$refs.dt.exportCSV();
    },
    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },
    
    async search() {
      this.table = [];
      this.filter='';
      this.cloneTable=[];
      this.cloneRe=[];
      if (
        this.responseArea_table.length == 0 ||
        this.disasterTypeSelected == null
      ) {
        if (this.responseArea_table.length == 0) {
          this.error_table = true;
        }
        if (this.disasterTypeSelected == null) {
          this.error_disaster = true;
        }
      } else {
        this.table = [];
        this.label = [];
        this.headerLocation = [];
        for (let i = 0; i < this.disasterTypeSelected.length; i++) {
          this.table.push({
            system_name: `${this.disasterTypeSelected[i].system_name}`,
            system_id: `${this.disasterTypeSelected[i].system_id}`,
          });
          // Doe ค้นหา  3/5 
          this.cloneTable.push({
            system_name: `${this.disasterTypeSelected[i].system_name}`,
            system_id: `${this.disasterTypeSelected[i].system_id}`,
          });
          // Doe ค้นหา  3/5 จบ
          this.label.push(`${this.disasterTypeSelected[i].system_name}`);
        }
        for (let i = 0; i < this.responseArea_table.length; i++) {
          this.headerLocation.push({
            id: `${this.responseArea_table[i].tambon_id}`,
            name: `${this.responseArea_table[i].tambon_name}`,
          });
        }
        this.loading = true;
        await this.axios
          .post(`${this.$url_service}/get/report`, {
            body: {
              topic: "get-report-riskarea",
              subtopic: "get-report-riskarea-graph",
              disaster: this.disasterTypeSelected,
              location: this.responseArea_table,
            },
          })
          .then((response) => {
            // console.log(response.data.data),
              (this.result_table = response.data.data);
              this.cloneRe = response.data.data

            // หัวตาราง
            this.H = ["ที่ตั้งพื้นทีเสี่ยงภัย"]
            this.headerLocation.forEach((e) => {
              this.H.push(e.name)
                })

            // คอลัมน์
            this.cop =[{dataKey:"disaster_type"}]
            this.headerLocation.forEach((e) => {
                
              this.cop.push({"dataKey":e.name})
               })
            
            // Doe : excel 3/3
            this.col = {"ที่ตั้งพื้นที่เสี่ยงภัย":"disaster_type"};
            this.headerLocation.forEach((e) => {
          
              Object.assign(this.col,{[e.name]:e.name})

            })
            // Doe : excel 3/3 end

            this.setSearchText_Footer()

          });
      }
      this.loading = false;
    },
    setSearchText_Footer(){
          this.text_Footer=false;
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.responseArea_table.length !== 0 ||
              this.disasterTypeSelected.length !== 0  ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "ที่ตั้งพื้นที่เสี่ยงภัย" && this.responseArea_table.length !== 0){
                  element.textShow = this.setArray_to_Text_PAT(this.responseArea_table,"province_name","amphur_name","tambon_name")
                }
                if(element.DataName === "ประเภทสาธารณภัย" && this.disasterTypeSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.disasterTypeSelected,"system_name")
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text(data,name){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },
    setArray_to_Text_PAT(data,name_P,name_A,name_T){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name_P !== null) {
          if (element[name_P] !== undefined) {
            text += "จังหวัด : "+element[name_P] + " ";
          }
          if (element[name_A] !== undefined) {
            text += "เขต/อำเภอ : "+element[name_A] + " ";
          }
          if (element[name_T] !== undefined) {
            text += "แขวง/ตำบล : "+element[name_T] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },

  // Doe ค้นหา  4/5 
  searchTable (){
      
      if (this.filter !== "") {
              this.result_table = this.cloneRe.filter((item) => {

              return item.system_name.includes(this.filter) 

              });

              this.table = this.cloneTable.filter((item) => {

              return item.system_name.includes(this.filter) 
              
              });
              this.c = []
              var temDataType =[]
              var temDataLocation =[]
              for (let index = 0; index < this.responseArea_table.length; index++) {
                let key = this.responseArea_table[index].tambon_name
                let keyLocation = {[key]:""};

                temDataLocation.push(keyLocation);
              }

              for (let index = 0; index < this.table.length; index++) {
                let textLoopTem = {disaster_type:`${this.table[index].system_name}`,temDataLocation}
                temDataType.push(textLoopTem)
                this.c.push({disaster_type:`${this.table[index].system_name}`})
              }

              // ส่วนใส่ข้อมูล

              for (let index = 0; index < this.result_table.length; index++) {
                const responseData = this.result_table[index];
                
                for (let index = 0; index < temDataType.length; index++) {
                  const elementTemDataType = temDataType[index];
                  const c2 = this.c[index]
                 
                    for (let index = 0; index < elementTemDataType.temDataLocation.length; index++) {
                      const nameLocation = elementTemDataType.temDataLocation[index];

                      if (elementTemDataType.disaster_type == responseData.system_name && Object.keys(nameLocation)[0] == responseData.tambon_name) {
                          let a = responseData.tambon_name    
                          nameLocation[responseData.tambon_name] = responseData.amount_type
                          elementTemDataType[responseData.tambon_name] = responseData.amount_type
                          c2[a] = responseData.amount_type

                      }
                    }
                }
                     
              }
              
              
              return (this.table,this.result_table)
            }else{
              this.table = this.cloneTable
              
              this.c = []
              let temDataType =[]
              let temDataLocation =[]
              for (let index = 0; index < this.responseArea_table.length; index++) {
                let key = this.responseArea_table[index].tambon_name
                let keyLocation = {[key]:""};
                temDataLocation.push(keyLocation);
              }
              
              for (let index = 0; index < this.table.length; index++) {
                let textLoopTem = {disaster_type:`${this.table[index].system_name}`,temDataLocation}
                temDataType.push(textLoopTem)
                this.c.push({disaster_type:`${this.table[index].system_name}`})
              }

              // ส่วนใส่ข้อมูล

              for (let index = 0; index < this.result_table.length; index++) {
                const responseData = this.result_table[index];
                
                for (let index = 0; index < temDataType.length; index++) {
                  const elementTemDataType = temDataType[index];
                  const c2 = this.c[index]
                 
                    for (let index = 0; index < elementTemDataType.temDataLocation.length; index++) {
                      const nameLocation = elementTemDataType.temDataLocation[index];

                      if (elementTemDataType.disaster_type == responseData.system_name && Object.keys(nameLocation)[0] == responseData.tambon_name) {
                          let a = responseData.tambon_name
                          nameLocation[responseData.tambon_name] = responseData.amount_type
                          elementTemDataType[responseData.tambon_name] = responseData.amount_type
                          c2[a] = responseData.amount_type
                       
                      }
                    }
                } 
              }
            }
            this.table = this.cloneTable
    },
    // Doe ค้นหา  4/5 จบ ค้นหา
    setData_Export(){
      const Sort_columns = this.$refs.dt.processedData
      var temDataType =[]
      var temDataLocation =[]
      let columns =[]

      if (Sort_columns !== null && Sort_columns !== undefined) {
        for (let index = 0; index < this.responseArea_table.length; index++) {
          var key = this.responseArea_table[index].tambon_name
          var keyLocation = {[key]:""};

          temDataLocation.push(keyLocation);
      }

      for (let index = 0; index < Sort_columns.length; index++) {
            var textLoopTem = {disaster_type:`${Sort_columns[index].system_name}`,temDataLocation}
            temDataType.push(textLoopTem)
            columns.push({disaster_type:`${Sort_columns[index].system_name}`})
      }

      // // ส่วนใส่ข้อมูล

      for (let index = 0; index < this.result_table.length; index++) {
            const responseData = this.result_table[index];
                
          for (let index = 0; index < temDataType.length; index++) {
                const elementTemDataType = temDataType[index];
                const c2 = columns[index]

          for (let index = 0; index < elementTemDataType.temDataLocation.length; index++) {
                const nameLocation = elementTemDataType.temDataLocation[index];

                if (elementTemDataType.disaster_type == responseData.system_name && Object.keys(nameLocation)[0] == responseData.tambon_name) {           
                  let a = responseData.tambon_name
                  nameLocation[responseData.tambon_name] = responseData.amount_type
                  elementTemDataType[responseData.tambon_name] = responseData.amount_type
                  c2[a] = responseData.amount_type        
                }
              }
            }           
          }
          return columns
      }else{
        return []
      }
          
    },
    confirmDelete() {
      this.responseArea_table = this.responseArea_table.filter(
        (val) => val !== this.responseAreaDelete
      );
      this.displayConfirmation = false;
      this.responseAreaDelete = null;
    },

    clearSearchField() {
      this.multiSelectClearFilerValue +=1;
      this.error_table = false;
      this.error_disaster = false;
      this.table = [];
      this.responseArea_table = [];
      this.disasterTypeSelected = null;
      this.H=[];
      this.c=[];
      this.cop=[];
      this.barData=[];

      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
      
      // Doe ค้นหา
      this.filter='';
      this.cloneTable=[];
      this.cloneRe=[];
      
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
  
   
        
  },
};
</script>

<style scoped>

.p-field {
  margin-bottom: 0rem;
  
}




</style>

<style>

@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}

.pdf{
  border: 5px solid rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}

.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">

.p-multiselect {
  // min-width: 18rem;
  max-width: 30rem;
  // width: fit-content;
}
@media screen and (max-width: 1540px) {
    .p-multiselect {
        max-width: 23rem !important
    }
}

@media screen and (max-width: 640px) {
    .p-multiselect {
        max-width: 10rem !important
    }
}

.multiselect-custom {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    
  }


  

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>



<style>
  /* ! ส่วนกราฟ */
  .chartAreaWrapper {
         width: 100%;
         overflow-x: scroll;
    }
  
  .walking-speed-chart{
         /* margin-top: 20px; */
         height: 80%;
         width: 880px;
    }
  
  
    @media screen and (max-width: 1540px) {
      .walking-speed-chart{
         height: 80%;
         width: 690px;
    }
  
  }
  
  /* ! จบส่วนกราฟ */
  </style>